<lib-select
  class="lang-select"
  [class.lang-select--icon-trigger]="triggerIcon"
  optionImgWidth="16px"
  [noNative]="noNative"
  [noBackground]="true"
  [withTrigger]="true"
  [dropdownIconsPath]="dropdownIconsPath"
  [options]="langOptions"
  [value]="langFormControl.value"
  (valueChange)="handleLangChange($event)"
>
  <div *ngIf="getLangOption(langFormControl.value) as langOption">
    <div class="lang-trigger" *ngIf="triggerIcon; else flagTrigger">
      <span class="lang-trigger__icon" [inlineSVG]="triggerIcon"></span>
      <span class="lang-trigger__label">{{ langOption.key }}</span>
    </div>
    <ng-template #flagTrigger>
      <div>
        <img [src]="langOption.img" /> <span>&nbsp;{{ langOption.key }}</span>
      </div>
    </ng-template>
  </div>
</lib-select>
